export default {
  action_to_realize: "Durchzuführende Aktionen",
  sign_action: "Speichern und unterzeichnen",
  complete: "Ausfüllen",
  toComplete: "Auszufüllen",
  due_date: "Fälligkeit",
  toSign: "Zu unterzeichnen",
  description: "Beschreibung",
  yearProgression: "Jahresfortschritt",
  progression: "Fortschritt",
  your_progression: "Ihre Füllrate",
  triad_progression: "Füllrate des Trinômes",
  question: "Frage",
  incoming: "Ausstehend",
  signature: "Unterschrift",
  questionnaire: "Fragebogen",
  questionnaires: "Fragebögen",
  yourAnswer: "Ihre Antwort: ",
  answerHere: "Hier antworten",
  commentHere: "Kommentar hier hinterlassen",
  comment: "Antwort kommentieren",
  answerComment: "Auf Kommentar antworten",
  sendComment: "Kommentar posten",
  sign: "Unterzeichnen",
  draft: "Als Entwurf speichern",
  sharedDraft: "Entwurf teilen",
  stopSharedDraft: "Entwurf nicht mehr teilen",
  stopSharedDraft_success: "Der Entwurf dieses Fragebogens wird nicht mehr geteilt",
  downloadPdf: "Fragebogen herunterladen",
  downloadPdfModel: "Vorlage herunterladen",
  interviewDate: "Datum des Unternehmensbesuchs",
  youAnswered: "Sie haben geantwortet:",
  sendFile: "Datei senden",
  sendDocument: "Dokument senden",
  takePicture: "Foto aufnehmen",
  fileSource: "Dateiquelle",
  yesSign: "Ja, ich unterzeichne",
  questionnaire_remove_title: "Fragebogen löschen",
  questionnaire_remove_sub_title: "Möchten Sie diesen Fragebogen wirklich löschen?",
  copy_questionnaire: "Fragebogen kopieren",
  questionnaire_copy_success: "Fragebogen erfolgreich kopiert!",
  questionnaire_removed_success: "Fragebogen erfolgreich gelöscht!",
  questionnaires_copied: "Versionen des obigen Fragebogens",
  signMessage: "Möchten Sie den Fragebogen wirklich unterzeichnen? Sie können Ihre Antworten danach nicht mehr ändern.",
  row_add_success: "Zeile erfolgreich hinzugefügt!",
  comment_add_success: "Kommentar erfolgreich hinzugefügt!",
  deleteMessage: "Möchten Sie diese Zeile wirklich löschen?",
  download_report: "Bericht herunterladen",
  signatory: "Unterzeichner",
  signatories: "Unterzeichner",
  expected_signature: "Unterschrift erwartet vor dem",
  signed_on: "Unterzeichnet am",
  commented_by: "Kommentiert von",
  success: "Erfolgreich gespeichert!",
  draftSuccess: "Entwurf erfolgreich gespeichert!",
  sharedSuccess: "Entwurf erfolgreich geteilt!",
  signedSuccess: "Erfolgreich unterzeichnet!",
  deletedQuestionnaire: "Dieser Fragebogen wurde gelöscht",
  addLine: "Zeile hinzufügen",
  "Competence calculated by your answers to the questionnaires":
    "Durch Ihre Antworten auf die Fragebögen berechnete Kompetenz",
  open_from: "Öffnung vom",
  no_crew_dates: "Keine Daten für die Gruppe",
  open_to: "bis",
  marks: "Noten",
  block_sign:
    "Die Unterzeichnung des Fragebogens ist erst nach der Validierung der anderen Mitglieder des Trinômes möglich.",
  no_mark: "Derzeit keine Noten",
  "Download dates": "Daten herunterladen",
  "Print all the questionnaires": "Alle Fragebögen drucken",
  answered: "hat geantwortet am",
  remove_answer_title: "Löschen einer Zeile",
  remove_answer: "Möchten Sie diese Antwortzeile wirklich löschen?",
  to_be_completed_from: " Auszufüllen vom ",
  to: " bis ",
  open_at: "Öffnung am ",
  closed_at: "Geschlossen am ",
  reopened: "Fragebogen wieder geöffnet",
  signed_at: "Unterzeichnet am ",
  export_questionnaire: "Fragebogen exportieren",
  import_questionnaire: "Fragebogen importieren",
  no_questionnaire: ({ plural }) =>
    plural(["Für dieses Jahr ist keine Kategorie eingetragen", "Für diese Kategorie ist kein Fragebogen eingetragen"]),
  empty_comment_label: "Kommentar",
  note: {
    title: ({ plural }) => plural(["Note", "Noten"]),
    question: {
      title: "Note der Frage",
    },
    cluster: {
      title: "Note des Rasters",
    },
    questionnaire: {
      title: "Noten des Fragebogens",
    },
    use_note_for_questionnaire: {
      title: "Die Note in die Gesamtnote des Fragebogens integrieren",
    },
    coefficient: "Koeffizient",
    coefficient_help:
      "Ermöglicht die Gewichtung der Bedeutung dieses Rasters im Vergleich zu den anderen Rastern des Fragebogens" +
      "\n Beispiel: Sie haben 2 Raster" +
      "\n - Raster 'Theoretisch' mit Koeffizient 2" +
      "\n - Raster 'Praktisch' mit Koeffizient 3" +
      "\n Das Raster 'Praktisch' wird 1,5-mal mehr in der Gesamtnote berücksichtigt",
    coefficient_question_help: "Multiplikator auf die Endnote dieses Rasters angewendet",
    convertion: "Bewertungsskala der Endnote",
    convertion_help:
      "Definiert die Skala, auf der die Endnote nach Berechnung des Durchschnitts aller Fragen dieses Rasters angegeben wird " +
      "\n Beispiel: Sie haben 5 Fragen mit je 2 Punkten. " +
      "\n - Wenn Sie 20 angeben, wird der Durchschnitt auf 20 angegeben " +
      "\n - Wenn der Lernende 8/10 erreicht, beträgt seine Endnote 16/20",
    convertion_question_help: "Die Note dieser Frage wird auf dieser Skala umgerechnet",
    question_conversion: "Skala pro Frage",
    question_conversion_help:
      "Definiert die Anzeigebewertungsskala für jede Frage dieses Rasters. Die erzielten Punkte können die Punkte der Frage nicht überschreiten!" +
      "\n Fall 1: Frage mit 5 Punkten" +
      "\n - Skala pro Frage = 20" +
      "\n Die angezeigten Noten sind: 5/20, 4/20, 3/20 usw. (die Note bleibt auf die 5 Punkte der Frage begrenzt)." +
      "\n Fall 2: Fragen mit 5 Punkten" +
      "\n Skala pro Frage = 4" +
      "\n Die Noten werden begrenzt: 4/4, 3/4, 2/4 usw. (die 5 möglichen Punkte werden auf maximal 4 reduziert)",
    question_conversion_question_help: "Maximal mögliche Note für diese Frage",
    see_details: "Details der Noten anzeigen",
    details: "Detail",
    mark_detail: "Notendetail",
    average: "Durchschnitt",
    mark_scale: "Bewertungsskala",
    maximal_mark: "Maximalnote",
    minimal_mark: "Minimalnote",
    maximal_mark_upper_than_mark_converted: "Die Maximalnote darf nicht höher als die angezeigte Note sein",
    maximal_mark_for_question: "Die Maximalnote für diese Frage beträgt:",
    maximal_mark_with_value: "Maximalnote: {mark1}/{mark2}",
    error: {
      no_genral_mark:
        "Das Notensystem ist für diese Frage aktiviert. Bitte geben Sie auch die allgemeine Bewertungsskala des Fragebogens ein, indem Sie hier klicken",
    },
    leave_empty: "Leer lassen, wenn die Maximalnote dieselbe wie in der Auswahlliste ist.",
  },
  summary_sheet: {
    title: "Notenübersicht",
    average: "Durchschnitt",
  },
  completeness_date_between_triad_start_date_and_end_date:
    "Das Vollständigkeitsdatum muss zwischen den Öffnungs- und Schließungsdaten der Mitglieder des Trinômes liegen",
  lock_questionnaire_heading: "Kopfzeile sperren/entsperren",
  use_contract_date: "Öffnung basierend auf den Daten der aktiven Verträge der Trinômes",
};
